import { Fragment, useEffect, useRef } from "react";
import { useState } from "react";
import {
  Button,
  Form,
  Row,
  Col,
  Dropdown,
  Overlay,
  Table,
} from "react-bootstrap";
import ReactDatePicker from "react-datepicker";
import Select from "react-select";
import {
  convertMomentDate,
  customerFullName,
  deliveryTypes,
  employeeFullName,
  formatForQty,
  maxTopPopperConfig,
  reactSelectTheme,
} from "../../utils/helpers";
import CustomerSelectModal from "../CustomerSelectModal";
import {
  AddCircleIcon,
  CreateInvoiceIcon,
  NoSelectedItemIcon,
  UserSolidIcon,
  CashSelectIcon,
  CreditSelectIcon,
  DirectTransferSelectIcon,
  ChequeSelectIcon,
  CustomerAccountSelectIcon,
  CreditMemoSelectIcon,
  EditIcon,
  DeleteIcon,
  TrashIcon,
} from "../Icons";
import NewCustomerModal from "../NewCustomerModal";
import NewItemModal from "../NewItemModal";
import PageHeader from "../PageHeader";
import CurrencyCustomInput from "../utils/CurrencyCustomInput";
import DatePickerCustomInput from "../utils/DatePickerCustomInput";
import ItemsTable from "../utils/ItemsTable";
import "./../../assets/scss/create-invoice.scss";
import AddItemModal from "./AddItemModal";
import currency from "currency.js";
import DotsVeritcalIcon from "mdi-react/DotsVerticalIcon";
import AccountPlusOutlineIcon from "mdi-react/AccountPlusOutlineIcon";
import { isEmpty } from "lodash";
import EditItemModal from "./EditItemModal";
import { useMemo } from "react";
import NumberCustomInput from "../utils/NumberCustomInput";
import { services } from "../../config";
import queryString from "query-string";
import { useQuery } from "react-query";
import { queryActions, reportActions } from "../../utils/reactQueryActions";
import { useFormik } from "formik";
import * as yup from "yup";
import Datetime from "react-datetime";
import { useMutation } from "react-query";
import { toast } from "react-toastify";
import SelectBankDialog from "../SelectBankDialog";
import useDebounce, { useUpdateEffect } from "../../utils/hooks";
import CustomerSelectorPopover from "../utils/CustomerSelectorPopover";
import { Popover } from "react-tiny-popover";
import AddCustomerItemModal from "./AddCustomerItemModal";
import AllocatedListModal from "./AllocatedListModal";
import moment, { isMoment } from "moment";
import { format } from "date-fns";
import CementEditRow from "./CementEditRow";
import { useAuth } from "../../hooks/useAuth";
import ModalLoader from "../utils/ModalLoader";
import { IsPrivileged } from "../DisplayChildElement";

export default function CreateCustomersInvoice({ isAllocationMode = false }) {
  const { backendUrl } = useAuth();
  const itemOverlayRef = useRef();
  const [showItemsPopover, setShowItemsPopover] = useState(false);
  const [showCustomerSelectorModal, setShowCustomerSelectorModal] = useState(
    false
  );
  const [selectedCustomer] = useState(null);

  const [showItemSelectorModal, setShowItemSelectorModal] = useState(false);
  const [showCreateNewCustomerModal, setShowCreateNewCustomerModal] = useState(
    false
  );
  const [showAllocatedListModal, setShowAllocatedListModal] = useState(false);
  const [pendingTransaction, setPendingTransaction] = useState(null);

  const [tableData, setTableData] = useState([]);
  const [editedItemIndex, setEditedItemIndex] = useState(0);
  const [editedSaleIndex, setEditedSaleIndex] = useState(0);

  const [salesForm, setSaleForm] = useState({});

  const formik = useFormik({
    initialValues: {
      Quantity: 1,
      PriceSold: 0,
      Discount: 0,
      loadingDate: moment(),
      deliveryDate: moment(),
      salesDate: moment(),
      truckNumber: "",
      driver: "",
      shippingCost: "",
      loadingCharge: "",
      offloadingCharge: "",
    },
    validationSchema: yup.object().shape({
      // PaymentType: yup.string().required(),
      // invoiceCat: yup.string().required("required"),
      Quantity: yup
        .string()
        .required("required")
        .min(1),
      PriceSold: yup.string().required("required"),
    }),
    onSubmit: values => {},
    onReset: () => {},
  });

  const submit = () => {};

  const showSelectBankDialog = async (props = {}) => {
    const bank = await SelectBankDialog({
      ...props,
      selectedBank: formik.values.BankName,
    });
    if (bank) {
      formik.setFieldValue("BankName", bank.bank);
      if (props.hasChequeNumber) {
        formik.setFieldValue("chequeNumber", bank.chequeNumber);
      }
    }
  };

  useEffect(() => {
    if (
      ["Credit/Debit Card", "Direct Bank Transfer"].includes(
        formik.values.PaymentType
      )
    ) {
      showSelectBankDialog();
    } else if (formik.values.PaymentType === "Cheque") {
      showSelectBankDialog({
        hasChequeNumber: true,
      });
    }
    if (formik.values.PaymentType === "Split Payment") {
      formik.setFieldValue("splitPaymentType", "card");
    } else {
      formik.setFieldValue("splitPaymentType", "");
    }
  }, [formik.values.PaymentType]);

  /* Split Payment  */
  useEffect(() => {
    if (["cheque"].includes(formik.values.splitPaymentType)) {
      showSelectBankDialog({
        hasChequeNumber: true,
      });
    } else if (
      ["card", "directTransfer"].includes(formik.values.splitPaymentType)
    ) {
      showSelectBankDialog({
        hasChequeNumber: false,
      });
    }
  }, [formik.values.splitPaymentType]);

  const fetchSetUpData = async () => {
    // await waitFor(5000);
    let response = await fetch(`${backendUrl}/api/invoice/set-up`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const { data } = await response.json();

    data.invoiceCat = data.invoiceCat.map(el => ({
      value: el.Product_Name,
      label: el.Product_Name,
    }));

    data.drivers = data.drivers
      .map(el => ({
        label: employeeFullName(el),
        value: employeeFullName(el),
      }))
      .filter(el => el.label);
    return data;
  };

  const { data = { invoiceCat: [], drivers: [] } } = useQuery(
    [queryActions.INVOICE_SETUP],
    () => fetchSetUpData(),
    {
      keepPreviousData: true,
    }
  );

  const fetchSalesReps = async () => {
    let response = await fetch(`${backendUrl}/api/customers/employees`, {
      method: "GET",
      headers: {
        Accept: "Application/json",
        "Content-Type": "Application/json",
      },
      credentials: "include",
    });

    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }

    const {
      data: { employees = [] },
    } = await response.json();

    return employees
      .map(el => ({
        label: employeeFullName(el),
        value: el.EmployeeID,
      }))
      .concat({
        label: "None",
        value: "None",
      });
  };

  const { data: salesReps = [] } = useQuery(
    ["SALES_REPS"],
    () => fetchSalesReps(),
    {
      keepPreviousData: true,
    }
  );

  const setSelectedCustomer = customerData => {
    // console.log(tableData[editedItemIndex], editedItemIndex);
    console.log(customerData);
    customerData.customerBalance = customerData.balance;
    delete customerData.balance;

    const oldCustomerInTable = tableData[editedItemIndex]
      ? tableData[editedItemIndex]?.sales.find(
          el => el.customer && el?.customer?.Cust_ID === customerData.Cust_ID
        )
      : null;
    if (!isEmpty(oldCustomerInTable)) {
      return toast.error("Customer has already been selected for this item");
    }
    tableData[editedItemIndex].sales[editedSaleIndex] = {
      ...tableData[editedItemIndex].item,
      ...tableData[editedItemIndex].values,
      ...tableData[editedItemIndex].sales[editedSaleIndex], // if user has values before retain
      customer: customerData,
    };
    setTableData([...tableData]);
  };

  const handleAddItem = item => {
    if (tableData.find(el => el.item.Bar_Code === item.item.Bar_Code)) {
      return toast.error("Item already added");
    }
    const newTableData = [
      ...tableData,
      {
        ...item,
        Item_Name: item.ItemName,
        Product_Name: item?.ATC_Product_Name || item.Product_Name,
        Cat_Name: item?.ATC_Cat_Name || item.Cat_Name,
        Sub_Cat_Name: item?.ATC_Sub_Cat_Name || item.Sub_Cat_Name,
      },
    ];

    setTableData(newTableData);
    setShowItemSelectorModal(false);
    handleAddCustomer(newTableData.length - 1, 0);
  };

  const handleRemoveCustomer = (index, salesIndex) => {
    // Check stock

    setTableData([
      ...tableData.map((table, tableIndex) => {
        if (tableIndex === index) {
          return {
            ...table,
            sales: table.sales.filter((el, i) => i !== salesIndex),
          };
        } else {
          return table;
        }
      }),
    ]);
  };

  const handleRowClick = (e, index, salesIndex) => {
    if (e.target.tagName === "TD") {
      setActiveRow(index, salesIndex);
    }
  };

  const setActiveRow = (index, salesIndex) => {
    setEditedItemIndex(index);
    setEditedSaleIndex(salesIndex);
  };

  const unsetActiveRow = () => {
    setEditedItemIndex(null);
    setEditedSaleIndex(null);
  };

  const salesQuantities = useMemo(() => {
    const sums = tableData.map(el => {
      const toSell = el.sales
        .map(el => el.Quantity)
        .reduce(
          (a, b) =>
            currency(a, {
              symbol: "",
              precision: 2,
              format: formatForQty,
            })
              .add(b)
              .format(),
          0
        );

      const canSell = Boolean(
        Number(el.item.quantityInStock) >= Number(toSell)
      );

      return {
        canSell,
        toSell,
      };
    });
    return sums;
  }, [tableData]);

  const handleEditCustomer = (index, salesIndex) => {
    setActiveRow(index, salesIndex);
    setShowCustomerSelectorModal(true);
  };

  const handleAddCustomer = (index, salesIndex) => {
    setActiveRow(index, salesIndex);
    setShowCustomerSelectorModal(true);
  };

  const editSale = ({ index, salesIndex, formValues }) => {
    tableData[index].sales[salesIndex] = {
      ...tableData[index].sales[salesIndex],
      ...formValues,
    };

    setTableData([...tableData]);
  };

  const createCustomerInvoice = async payload => {
    let response = await fetch(
      `${backendUrl}/api/invoice/create-cement-invoice`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const createCustomerInvoiceMutation = useMutation(
    payload => createCustomerInvoice(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        setTableData([]);
        setPendingTransaction(null);
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  const createAtcAllocation = async payload => {
    let response = await fetch(
      `${backendUrl}/api/invoice/create-atc-allocation`,
      {
        method: "POST",
        credentials: "include",
        body: JSON.stringify(payload),
        headers: {
          Accept: "Application/json",
          "Content-Type": "Application/json",
        },
      }
    );
    if (!response.ok) {
      response = await response.json();
      throw new Error(response.message);
    }
    const res = await response.json();
    return res;
  };
  const createAtcAllocationMutation = useMutation(
    payload => createAtcAllocation(payload),
    {
      onSuccess: ({ message }) => {
        toast.success(message);
        setTableData([]);
      },
      onError: ({ message = "" }) => {
        toast.error(`Unable to perform action: ${message}`);
      },
    }
  );

  const activeMutation = isAllocationMode
    ? createAtcAllocationMutation
    : createCustomerInvoiceMutation;

  const canNotCreateInvoice = useMemo(() => {
    return salesQuantities.find(el => !el.canSell);
  }, [tableData]);

  const handleSelectedAllocation = allocation => {
    const grouped = [];
    allocation.items.forEach(permit => {
      let sale;
      try {
        sale = JSON.parse(permit.atcAllocationData);
      } catch (err) {
        return;
      }
      let bucket = grouped.find(el => el.item.Bar_Code === sale.Bar_Code);
      if (!bucket) {
        bucket = { item: { ...sale }, sales: [] };
        grouped.push(bucket);
      }
      bucket.sales.push(sale);
    });
    setTableData(grouped);
    setPendingTransaction(allocation.TransactionID);
    setShowAllocatedListModal(false);
  };

  const sendInvoice = () => {
    if (canNotCreateInvoice) {
      return toast.error("Quantity entered is greater than quantity in Stock");
    }

    const payload = tableData
      .map(el => el.sales)
      .flat()
      .map(el => ({
        ...el,
        items: [{ ...el, salesDate: convertMomentDate(el.salesDate) }],
      }));

    if (payload.find(el => Number(el.Quantity) <= 0)) {
      return toast.error("Quantity cannot be less than or equal to 0");
    }

    if (isAllocationMode) {
      if (payload.find(el => !el.customer?.Cust_ID)) {
        return toast.error("Every item must have a customer selected");
      }
      return createAtcAllocationMutation.mutate({
        customerSales: payload,
      });
    }

    createCustomerInvoiceMutation.mutate({
      customerSales: payload,
      ...(pendingTransaction ? { pendingTransaction } : {}),
    });
  };

  const removeItem = Bar_Code => {
    setTableData(old => old.filter(item => item.Bar_Code === Bar_Code));
  };

  // isprivileged
  return (
    <IsPrivileged
      roleName={
        isAllocationMode ? ["ATC Allocation"] : ["Pre-order", "Make Invoice"]
      }
    >
      <main className="create-invoice">
        <PageHeader
          name={isAllocationMode ? "ATC Allocation" : "ATC Distribution center"}
          description={
            isAllocationMode
              ? "Allocate ATC stock batches to a customer for later invoicing."
              : "Create a new transaction invoice with your customers."
          }
          icon={<CreateInvoiceIcon />}
        />
        <div className="p-3 content">
          <div className="d-flex content-holder rounded">
            <section className="item-details customers">
              <div>
                <header>
                  <h1>Invoice</h1>
                </header>

                {!isAllocationMode && pendingTransaction && (
                  <p className="text-muted mt-3 mb-0">
                    Populated from allocation for{" "}
                    <b>
                      {[
                        ...new Set(
                          tableData
                            .flatMap(el => el.sales)
                            .map(el => customerFullName(el.customer))
                        ),
                      ].join(", ")}
                    </b>{" "}
                    ({pendingTransaction})
                  </p>
                )}

                <div className="selected-data-area mt-3">
                  {tableData.map(({ item, sales }, index) => (
                    <Fragment key={item.Bar_Code}>
                      <h2 className="h2 mb-2">{item.Item_Name}</h2>
                      <div className="mb-3 d-flex gap-3 align-items-center">
                        <Button
                          variant="outline-danger"
                          className="border-0"
                          onClick={() => removeItem(item.Bar_Code)}
                          size="sm"
                        >
                          <DeleteIcon />
                        </Button>

                        <div>
                          <p>
                            ATC Code: <b> {item.ATC_Code}</b>
                          </p>
                        </div>

                        <div>
                          <p>
                            Quantity In Stock: <b>{item.quantityInStock}</b>
                          </p>
                        </div>

                        <div>
                          <p>
                            Quantity To Sell:{" "}
                            <b>{salesQuantities[index].toSell}</b>
                          </p>
                        </div>

                        <div>
                          {!isEmpty(salesQuantities) &&
                          !salesQuantities[index].canSell ? (
                            <p className="text-danger fw-5">
                              Quantity entered is greater than quantity in Stock{" "}
                            </p>
                          ) : null}
                        </div>
                      </div>
                      <div className="table-holder">
                        <Table
                          responsive
                          borderless
                          hover
                          striped
                          className="product-table text-nowrap"
                        >
                          <thead>
                            <tr>
                              <th />
                              <th>Business Name</th>
                              <th>Sales Rep</th>
                              <th>ATC</th>
                              <th>Item</th>
                              <th>Quantity</th>
                              <th>Plant</th>
                              <th>Region</th>
                              <th>Depot</th>
                              <th>Stock In Date</th>
                              <th>Price Sold</th>
                              <th>Discount</th>
                              {/* <th>Product name</th> */}
                              {/* <th>Unit Price</th> */}
                              <th>Cost</th>
                              <th>Benchmark Cost</th>
                              <th>Profit</th>

                              <th>LoadingDate</th>
                              <th>Delivery Date</th>
                              <th>Delivery</th>
                              <th>Driver</th>
                              <th>Driver Phone No.</th>
                              <th>Truck No.</th>
                              <th>Trip No.</th>
                              <th>Loading Charge</th>
                              <th>Offloading Charge</th>
                              <th>Transport Charge / Shipping Cost</th>
                              <th>Sales Date</th>

                              <th>Tax Type</th>
                              <th>Tax Amount</th>
                              <th>Payment Type</th>
                              <th>Subtotal</th>
                              <th>Amount Due</th>
                              <th>Amount Paid</th>
                              <th>Balance</th>
                              <th>Due In (days)</th>
                            </tr>
                          </thead>
                          <tbody>
                            {sales.map((el, salesIndex) => (
                              <Fragment key={el.customer?.Cust_ID}>
                                <CementEditRow
                                  sale={el}
                                  drivers={data.drivers}
                                  salesReps={salesReps}
                                  deliveryTypes={deliveryTypes}
                                  index={index}
                                  salesIndex={salesIndex}
                                  handleEditCustomer={handleEditCustomer}
                                  handleRemoveCustomer={handleRemoveCustomer}
                                  editSale={editSale}
                                />
                              </Fragment>
                            ))}
                          </tbody>
                        </Table>
                      </div>
                      <div className="d-flex gap-3">
                        <button
                          onClick={() => handleAddCustomer(index, sales.length)}
                          className="btn text-primary my-3 d-flex align-items-center gap-2"
                          type="button"
                        >
                          <AccountPlusOutlineIcon />
                          Select Customer
                        </button>

                        <button
                          onClick={() => setShowCreateNewCustomerModal(true)}
                          className="btn text-primary my-3 d-flex align-items-center gap-2"
                          type="button"
                        >
                          Create New Customer
                        </button>
                      </div>
                      <hr />
                    </Fragment>
                  ))}

                  {/*  */}

                  <button
                    onClick={() => setShowItemSelectorModal(true)}
                    type="button"
                    className="btn text-primary my-3 d-flex align-items-center gap-2"
                  >
                    <AddCircleIcon />
                    Add an Item
                  </button>

                  {!isAllocationMode && (
                    <button
                      onClick={() => setShowAllocatedListModal(true)}
                      type="button"
                      className="btn text-primary my-3 d-flex align-items-center gap-2"
                    >
                      <AddCircleIcon />
                      Pick from Allocated List
                    </button>
                  )}

                  {/*  No item  */}
                  {isEmpty(tableData) ? (
                    <div className="no-item my-5">
                      <div className="info">
                        <NoSelectedItemIcon />
                        <h2 className="mb-2">Haven't selected an item yet</h2>
                        <p>
                          You can click +Add Item Button to add an item to the
                          table.
                        </p>
                      </div>
                    </div>
                  ) : null}
                </div>
              </div>

              {!isEmpty(tableData) && (
                <div className="d-flex justify-content-between total-info">
                  <div />
                  <div>
                    <Button
                      onClick={() => sendInvoice()}
                      disabled={activeMutation.isLoading}
                      type="button"
                      className="py-3 px-5"
                    >
                      {activeMutation.isLoading
                        ? "Please wait..."
                        : isAllocationMode
                        ? "Allocate to Customer"
                        : " Post Invoice"}
                    </Button>
                  </div>
                </div>
              )}
            </section>
          </div>
        </div>

        {/*   Modals */}
        {showCustomerSelectorModal && (
          <CustomerSelectModal
            setShowCustomerSelectorModal={setShowCustomerSelectorModal}
            setSelectedCustomer={setSelectedCustomer}
            withCredit={true}
          />
        )}

        {showItemSelectorModal && (
          <AddCustomerItemModal
            showItemSelectorModal={showItemSelectorModal}
            setShowItemSelectorModal={setShowItemSelectorModal}
            handleAddItem={handleAddItem}
            drivers={data.drivers}
            deliveryTypes={deliveryTypes}
            selectedItemsBarcodes={tableData
              .map(el => el.item)
              .map(el => el.Bar_Code)}
          />
        )}

        {showCreateNewCustomerModal && (
          <NewCustomerModal
            showCreateNewCustomerModal={showCreateNewCustomerModal}
            setShowCreateNewCustomerModal={setShowCreateNewCustomerModal}
            setSelectedCustomer={setSelectedCustomer}
          />
        )}

        {showAllocatedListModal && (
          <AllocatedListModal
            setShowAllocatedListModal={setShowAllocatedListModal}
            handleSelectedAllocation={handleSelectedAllocation}
          />
        )}

        <ModalLoader show={activeMutation.isLoading} />
      </main>
    </IsPrivileged>
  );
}
